import { content as terminContent } from '../../../utils';

export const content = {
  ...terminContent,
  draggableId: 'planungsinformationen',
  heading: 'Planung',
  fields: {
    dauer: 'Dauer',
    veranstaltungen: 'Veranstaltungen',
    durchgaenge: 'Durchgänge',
    raumgroesse: 'Benötigte Raumgröße',
    teilnehmer: 'Erwartete Teilnehmer',
    bestuhlungsart: 'Bestuhlungsart',
    gruppenraum: 'Gruppenraum',
    tool: 'Tool',
    musskopplung: 'Musskopplung',
    terminreihe: 'Terminreihe',
    verknuepfung: 'Verknüpfung (B)LOP',
    locationBesonderheiten: 'Besonderheiten der Location',
  },
  raumgroesseTooltip: 'Es konnte keine Raumgröße berechnet werden, da nicht alle erforderlichen Daten vorhanden sind.',

  locationBesonderheiten: {
    PC_CENTER: 'PC-Center',
  },
} as const;
